import React from 'react';
import styles from './style/progress-bar.module.scss';
import PropTypes from 'prop-types'

const ProgressBar = ({ totalLevels, level, className = '' }) => {
    const progress = level * 100 / totalLevels;

    return (
        <div className={`${className} ${styles['progress-container']}`}>
            <div className={`${styles['progress-bar']}`}>
                <div className={`${styles['active-segment']}`} style={{ width: `${progress}%` }} />
            </div>
        </div>
    )
};

ProgressBar.propTypes = {
    totalLevels: PropTypes.number,
    level: PropTypes.number.isRequired,
    className: PropTypes.string
}

ProgressBar.defaultProps = {
    totalLevels: 5
}

export default ProgressBar;
